// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\(tabs)\\_layout.tsx"); } },
  "./(tabs)/alerts.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\(tabs)\\alerts.tsx"); } },
  "./(tabs)/conditions.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\(tabs)\\conditions.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\(tabs)\\index.tsx"); } },
  "./(tabs)/me.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\(tabs)\\me.tsx"); } },
  "./(tabs)/search.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\(tabs)\\search.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\_layout.tsx"); } },
  "./condition/[id].tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\condition\\[id].tsx"); } },
  "./deal/[id].tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\deal\\[id].tsx"); } },
  "./design/a.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\design\\a.tsx"); } },
  "./design/b.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\design\\b.tsx"); } },
  "./design/s.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\design\\s.tsx"); } },
  "./design/t.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\design\\t.tsx"); } },
  "./welcome.tsx": { enumerable: true, get() { return require("C:\\dev\\AI DEAL HUNTER\\mobile\\app\\welcome.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;